module.exports = __webpack_public_path__ + "img/login-img.5c006886.png";